module.exports = __webpack_public_path__ + "img/index-download-new.e7ab0ae9.jpg";